<template>
    <div class="live_item test_user" 
        v-if="msg&&!~dataView.indexOf(msg.kind)"
        >
        
        <div
            class="is_only_self_show is_fans_show"
            v-if="msg.is_fans_show == 1"
        >
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                <circle cx="6.41524" cy="4.02844" r="2.75" stroke="#939393"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M9.91791 12.7216C9.91791 12.7216 7.45866 11.1794 7.32564 9.97992C7.19261 8.78043 7.95131 8.22162 8.62177 8.22162C9.29223 8.22162 9.91791 8.68735 9.91791 8.68735C9.91791 8.68735 10.5977 8.22162 11.2744 8.22162C11.9511 8.22162 12.561 9.03925 12.4564 9.97992C12.3519 10.9206 9.91791 12.7216 9.91791 12.7216Z" stroke="#939393"/>
                <path d="M6.41524 6.77844C6.41524 6.77844 1.75855 6.56079 1.53181 11.6956C1.53181 11.8244 1.61436 11.8841 1.65187 11.9392C1.76712 12.1086 2.23501 12.1739 2.23501 12.1739H6.41524" stroke="#939393" stroke-linecap="round"/>
            </svg>
        仅粉丝可见</div>
        
        <div class="live_header">
            <dl class="user_detail" v-if="live&&live.image">
                <dt @click="handleClickToDetail(msg.kind, live.id)">
                    <img :src="live.image" alt="用户头像" />
                </dt>
                <dd>
                    <h4>
                        <span
                            @click="handleClickToDetail(msg.kind, live.id)"
                            class="user_name"
                        >{{live.title}}</span>
                        <span class="user_symbol" v-if="live.serve_vip === 'yes'">
                            <img alt :src="require('@/assets/images/icon-killer@2x.png')" />
                        </span>
                        <span class="user_symbol" v-if="live.is_official === 'yes'">
                            <img alt :src="require('@/assets/images/xunzhang_icon_lanv@2x.png')" />
                        </span>
                        <span class="user_symbol" v-if="live.is_official === 'no'">
                            <img
                                alt
                                :src="require('@/assets/images/xunzhang_icon_icon_dav@2x.png')"
                            />
                        </span>

                        <span class="user_symbol" v-if="live.is_elite === 'yes'">
                            <img alt src="https://cdn.aigupiao.com/static/pc/img/medal_ico4.png" />
                        </span>
                        <span class="user_symbol" v-if="live.is_talent && live.is_talent === 'yes'">
                            <img :src="require('@/assets/images/icon-daren@2x.png')" alt="达人" />
                        </span>
                    </h4>
                    <p
                        v-if="msg.rec_time_desc"
                    >发表于 {{msg.rec_time_desc}}&nbsp;&nbsp;&nbsp;{{msg.view_num}}</p>
                </dd>
            </dl>
            <div class="user_operation" v-if="'path' === '/default/userProfiles/:userid'">
                <img alt :src="require('@/assets/images/icon-there-dot@2x.png')" />
            </div>
        </div>
        <div>
            <!-- vip消息 -->
            <div v-if="msg.kind === 'vip'">
                <div v-if="msg.is_show === 'no' || !msg.content">
                    <div class="members_only">
                        <div
                            class="members_only_free"
                            @click="handleClickToLiveDetail(msg.id)"
                            v-html="msg.brief"
                        ></div>
                        <div class="members_only_box">
                            <div class="vip_nosee_company" @click="openDownloadAppPop">
                                <span></span>
                                <div class="vip_company_info open_member">
                                    <b>会员专享信息，请开通VIP服务查看</b>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="msg.is_show === 'yes' || msg.content ">
                    <div
                        class="member_brief"
                        @click="handleClickToLiveDetail(msg.id)"
                        v-html="msg.brief"
                    ></div>
                    <div class="member_news">
                        <div class="member_news_header">
                            <dl>
                                <dt>
                                    <img
                                        alt
                                        :src="require('@/assets/images/icon-vip-yellow@2x.png')"
                                    />
                                </dt>
                                <dd>
                                    <h4>
                                        以下内容会员独享
                                        <span v-if="msg.vip_group_info ">({{msg.vip_group_info}})</span>
                                    </h4>
                                    <p>本收费产品由{{msg.company}}提供</p>
                                </dd>
                            </dl>
                        </div>
                        <div class="member_news_content" v-html="msg.content"></div>
                        <div
                            v-if="(msg.image_thumb && msg.image_thumb.length > 0) || (msg.menus && msg.menus.length > 0)"
                        >
                            <image-viewpoint :msg="msg"></image-viewpoint>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 是否是高手免费消息 -->
            <div
                v-if="msg.kind === 'free' || msg.kind === 'live_msg' || msg.kind === 'u_msg' ||msg.kind === 'express'|| msg.kind === 'news'  || msg.kind === 'stock_discuss' ||  (msg.kind === 'user_msg' &&  msg.content_type === '0' )"
            >
                <!-- 非仅粉丝可见 或者 仅粉丝可见+可见 -->
                <div v-if="msg.is_fans_show == 0 || is_fans_show_ok === true ">
                    <!-- 文字部分 -->
                    <div class="live_content">
                        <div @click="handleClickToLiveDetail(msg.id)">
                            <div v-html="msg.content"></div>
                        </div>
                    </div>
                    <!-- 音频消息 -->
                    <div v-if="msg.audio && msg.audio !== ''">
                        <audio-msg-wrap :audioLen="msg.audio_len"></audio-msg-wrap>
                    </div>
                    <!-- 图片部分有图片或者视屏则都显示缩略图 -->
                    <div
                        v-if="msg.image_thumb && msg.image_thumb.length > 0  || (msg.menus && msg.menus.length > 0) "
                    >
                        <image-viewpoint :msg="msg"></image-viewpoint>
                    </div>
                    <!-- 分享竞猜 -->
                    <div
                        v-if="msg.guess&&msg.guess.title"
                        class="transpond_plate_wrap transpond_guess"
                        @click="hanleClickToPage(`/StockGuess/market/id/${item.guess.id}`)"
                    >
                        <div class="transpond_plate_content">
                            <div class="transpond_title">
                                <img
                                    alt
                                    src="https://cdndev.aigupiao.com/static/pc/img/plate_ico_1.png"
                                />
                                <div class="plate_img_text">趣味竞猜</div>
                            </div>
                            <div class="transpond_detail">
                                <div class="guess_list">
                                    <h5 class="guess_title">{{msg.guess.title}}</h5>
                                    <p class="guess_num">参与人数：{{msg.guess.total_num}}</p>
                                </div>
                                <div class="guess_btns">
                                    <div class="guess_btn">查看竞猜</div>
                                    <div class="guess_btn">跟单</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- 分享板块 -->
                    <div v-if="msg.share_kind === 'theme'">
                        <div class="transpond_plate_wrap">
                            <div class="transpond_plate_content">
                                <div @click="openDownloadAppPop" class="transpond_title">
                                    <img
                                        alt
                                        src="https://cdndev.aigupiao.com/static/pc/img/plate_ico_1.png"
                                    />
                                    <div class="plate_img_text">板块</div>
                                </div>
                                <div class="transpond_detail">
                                    <div @click="openDownloadAppPop" class="transpond_list">
                                        <p class="plate">
                                            <span>{{ msg.share_msg.title }}</span>
                                            &nbsp;&nbsp;
                                            <span
                                                class="to_red"
                                                v-if="isGoUp(msg.share_msg.chg_pct)"
                                            >+{{twoDecimalPlaces(msg.share_msg.chg_pct) }}</span>
                                            <span
                                                class="to_green"
                                                v-else
                                            >{{twoDecimalPlaces(msg.share_msg.chg_pct) }}</span>
                                        </p>
                                        <div class="plate_info_right">
                                            <p
                                                class="plate_stock_info"
                                                v-for="item in msg.share_msg.head_stocks.slice(0,2)"
                                            >
                                                <span>{{ item.stock_name }}</span>
                                                &nbsp;&nbsp;
                                                <span
                                                    :class="isGoUp(item.stock_rise) ? 'to_red' : 'to_green'"
                                                >{{item.stock_rise}}%</span>
                                            </p>
                                        </div>
                                    </div>
                                    <div
                                        v-if="!msg.share_msg.is_follow || msg.share_msg.is_follow === 'no'"
                                        @click="handleClickToAddOptional(msg.share_msg.symbol ,'BK', msg.share_msg)"
                                        class="add_optional"
                                    >加自选</div>
                                    <div
                                        v-else
                                        @click="handleClickToDelOptional(msg.share_msg.symbol ,'BK', msg.share_msg)"
                                        class="add_optional del_optional"
                                    >已添加</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- 分享股票 -->
                    <div v-if="msg.share_kind && msg.share_kind === 'stock' && !msg.guess">
                        <div class="transpond_plate_wrap">
                            <div class="transpond_plate_content">
                                <div
                                    class="transpond_title"
                                    @click="handleClickToStockPage(msg.share_msg.stock_code)"
                                >
                                    <img
                                        alt
                                        src="https://cdndev.aigupiao.com/static/pc/img/plate_ico_1.png"
                                    />
                                    <div class="plate_img_text">股票</div>
                                </div>
                                <div class="transpond_detail">
                                    <div
                                        class="transpond_list"
                                        @click="handleClickToStockPage(msg.share_msg.stock_code)"
                                    >
                                        <p class="plate">
                                            <span>{{msg.share_msg.stock_name}}</span>
                                            <span class="stock-code">{{msg.share_msg.stock_code}}</span>
                                        </p>
                                        <div class="plate_info_right">
                                            <p
                                                v-if="msg.share_msg.stock_market"
                                                :class="['plate_stock_info', isGoUp( msg.share_msg.stock_market.chg_pct ) ? 'to_red' : 'to_green']"
                                            >
                                                <span>{{msg.share_msg.stock_market.price}}</span>
                                                &nbsp;&nbsp;
                                                <span>{{isGoUp( msg.share_msg.stock_market.chg_pct ) ? '+' : ''}}{{ msg.share_msg.stock_market.chg_pct }}%</span>
                                            </p>
                                            <p class="plate_stock_info">
                                                <span>{{msg.share_msg.comment_num}}</span>
                                            </p>
                                        </div>
                                    </div>
                                    <div
                                        v-if="!msg.share_msg.is_follow || msg.share_msg.is_follow === 'no'"
                                        @click="handleClickToAddOptional(msg.share_msg.stock_code, 'SH', msg.share_msg)"
                                        class="add_optional"
                                    >加自选</div>
                                    <div
                                        v-else
                                        @click="handleClickToDelOptional(msg.share_msg.stock_code, 'SH', msg.share_msg)"
                                        class="add_optional del_optional"
                                    >已添加</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- 分享期货、分享k线训练营、分享语音直播间 -->
                    <div
                        v-if="msg.share_kind && !!~['futures','kline_game','share_audio_live'].indexOf(msg.share_kind)"
                    >
                        <div class="nonsupport_box">
                            <a
                                href="https://a.app.qq.com/o/simple.jsp?pkgname=com.aigupiao.ui"
                            >[暂不支持查看此分享内容,请下载APP查看]</a>
                        </div>
                    </div>
                    <!-- 属于转发的模块 -->
                    <div
                        v-if="msg.forward_info && msg.forward_info.length"
                        v-for="item in msg.forward_info"
                    >
                        <div v-if="item.data.o_kind === 'stock_group'">
                            <div class="nonsupport_box">
                                <a
                                    href="https://a.app.qq.com/o/simple.jsp?pkgname=com.aigupiao.ui"
                                >[暂不支持查看此分享内容,请下载APP查看]</a>
                            </div>
                        </div>
                        <div v-if="item.kind === 'express'">
                            <div
                                class="transpond_important_news"
                                @click="handleClickNewsDetail(item.data.id)"
                            >
                                <p>
                                    <span class="important_news_mark">[资讯]</span>
                                    <span>{{item.data.content}}</span>
                                </p>
                            </div>
                        </div>
                        <div
                            v-if="item.kind === 'news' || ((item.kind === 'live_msg' || item.kind === 'user_msg') &&item.data.kind==='charge')"
                        >
                            <div class="transpond_special_column">
                                <div class="user_msg">
                                    <span
                                        class="user_name"
                                        v-if="item.kind === 'user_msg'"
                                        @click="handleClickToDetail(item.kind, item.u_id)"
                                    >{{item.data.name}} :</span>
                                    <span
                                        class="user_name"
                                        v-else
                                        @click="handleClickToDetail(item.kind, item.l_id)"
                                    >
                                        {{item.data.l_title}}
                                        {{ !item.data.l_title || item.data.l_title === '' ? '' : ':'}}
                                    </span>
                                    <span class="content_type">
                                        <img
                                            :src="require('@/assets/images/column_logo@2x.png')"
                                            alt
                                        />
                                    </span>
                                </div>
                                <dl
                                    class="transpond_box"
                                    @click="handleClickToTranspondLiveDetail(item.data.kind, item.data.id)"
                                >
                                    <dt class="user_img">
                                        <img
                                            :src="item.data.l_image || item.data.image&&item.data.image.length&&item.data.image[0]"
                                            aalt="专栏作者头像"
                                        />
                                    </dt>
                                    <dd class="transpond_content">
                                        <h4 class="transpond_title">{{item.data.title}}</h4>
                                        <p
                                            class="transpond_brief"
                                            v-html="item.data.content || item.data.brief || item.data.last_content "
                                        ></p>
                                    </dd>
                                </dl>
                            </div>
                        </div>
                        <div v-if="!!~['live_msg','user_msg'].indexOf(item.kind)">
                            <div v-if="!!~['vip'].indexOf(item.kind) && item.is_show === 'yes'">
                                <div
                                    class="member_brief transpond"
                                    @click="handleClickToLiveDetail(msg.id)"
                                >
                                    <span class="user_name">{{item.l_title}}:</span>
                                    {{item.brief}}
                                </div>
                                <div
                                    class="member_news"
                                    @click="handleClickToLiveDetail(item.data.id, item.data.kind)"
                                >
                                    <div class="member_news_header">
                                        <dl>
                                            <dt>
                                                <img
                                                    alt
                                                    :src="require('@/assets/images/icon-vip-yellow@2x.png')"
                                                />
                                            </dt>
                                            <dd>
                                                <h4>以下内容会员独享 {{item.vip_group_info ? '(' + item.vip_group_info + ')' : null}}</h4>
                                                <p>本收费产品由{{ item.company }}提供</p>
                                            </dd>
                                        </dl>
                                    </div>
                                    <div
                                        class="member_news_content"
                                        v-html="item.last_content || item.brief || item.content"
                                    ></div>
                                    <div
                                        v-if="(!item.image_thumb || item.image_thumb.length === 0) && ((item.menus && item.menus.length > 0) || (item.image && item.image.length > 0))"
                                    >
                                        <div class="thumbnail transmit_image">
                                            <div v-for="item in item.menus">
                                                <!-- <VedioImg video={item} ></VedioImg> -->
                                            </div>
                                            <div class="img-item" v-for="item,index in item.image">
                                                <img
                                                    :preview="randomStr"
                                                    @load="$previewRefresh"
                                                    alt
                                                    v-lazy="item"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- 转发会员消息 -->
                            <div
                                v-if="!!~['vip'].indexOf(item.data.kind) && item.data.is_show === 'no'"
                            >
                                <div class="members_only">
                                    <div
                                        class="members_only_free transpond"
                                        @click="handleClickToLiveDetail(item.data.id, item.data.kind)"
                                    >
                                        <span class="user_name">{{ item.data.l_title }}:</span>
                                        <span>{{ item.data.brief }}</span>
                                    </div>
                                    <div class="members_only_box zf border-1px">
                                        <div class="vip_nosee_company" @click="openDownloadAppPop">
                                            <span></span>
                                            <div class="vip_company_info open_member">
                                                <b>会员专享信息，请开通VIP服务查看</b>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="!~['charge','vip'].indexOf(item.data.kind)">
                                <div
                                    class="transpond_ordinary"
                                    v-if="item.data.o_kind !== 'stock_group'"
                                >
                                    <div class="transpond_ordinary_content">
                                        <span
                                            class="user_name"
                                            v-if="item.data.kind === 'user_msg'"
                                            @click="handleClickToDetail( item.data.kind, item.data.u_id)"
                                        >{{item.data.name}}：</span>
                                        <span
                                            class="user_name"
                                            v-else
                                            @click="handleClickToDetail( item.data.kind, item.data.l_id)"
                                        >{{item.data.l_title}}：</span>

                                        <span
                                            @click="handleClickToLiveDetail(item.data.id, item.data.kind)"
                                            v-html="item.data.content || item.data.last_content"
                                        ></span>
                                    </div>

                                    <div v-if="msg.forward_is_vote === 'yes'">
                                        <div class="dl_check_box">
                                            <a
                                                href="https://a.app.qq.com/o/simple.jsp?pkgname=com.aigupiao.ui"
                                            >[暂不支持查看此分享内容，请下载app查看]</a>
                                        </div>
                                    </div>
                                    <!-- 转发语音消息 -->
                                    <div v-if="item.data.audio && item.data.audio !== ''">
                                        <audio-msg-wrap :audioLen="parseInt(item.data.audio_len)"></audio-msg-wrap>
                                    </div>
                                    <!-- 满足消息本身没有图片并且转发的消息有图片时显示转发的图片-->
                                    <div v-if="item.data.album&&item.data.album.kind==='album'">
                                        <div class="video_special" @click="$downapppop.open">
                                            <div class="video_cover">
                                                <img
                                                    :src="item.data.album.v_cover || require('@/assets/images/default-video.jpg')"
                                                    alt
                                                />
                                                <div class="play_btn">
                                                    <img
                                                        :src="require('@/assets/images/icon-play-btn@2x.png')"
                                                        alt
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div
                                            class="thumbnail transmit_image"
                                            v-if="item.data.image.length  || item.data.small_video"
                                        >
                                            <div
                                                class="img-item"
                                                v-if="item.data.small_video&&JSON.parse(item.data.small_video)"
                                            >
                                                <div class="vedio_img">
                                                    <span class="vedio_image">
                                                        <img
                                                            class="vedio_image_img"
                                                            :src="JSON.parse(item.data.small_video).video_image_url"
                                                            alt
                                                        />
                                                        <!-- todo -->
                                                        <p
                                                            @click="$videoplay.open(JSON.parse(item.data.small_video).video)"
                                                        >
                                                            <img
                                                                class="vedio_play"
                                                                src="https://cdn.aigupiao.com/static/wrap/img/media_play_ico.png"
                                                                alt
                                                            />
                                                            <span class="vedio_time">
                                                                <img
                                                                    class="vedio_time_icon"
                                                                    src="https://cdn.aigupiao.com/static/wrap/img/small_video_ico1.png"
                                                                    alt
                                                                />
                                                                <i>{{JSON.parse(item.data.small_video).video_len}}</i>
                                                            </span>
                                                        </p>
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="img-item" v-for="item in item.data.image">
                                                <img
                                                    :preview="randomStr"
                                                    @load="$previewRefresh"
                                                    alt
                                                    v-lazy="item"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="forward-main">
                                        <div v-if="item.theme_info">
                                            <div class="transpond_plate_wrap">
                                                <div class="transpond_plate_content">
                                                    <div
                                                        @click="openDownloadAppPop"
                                                        class="transpond_title"
                                                    >
                                                        <img
                                                            alt
                                                            src="https://cdndev.aigupiao.com/static/pc/img/plate_ico_1.png"
                                                        />
                                                        <div class="plate_img_text">板块</div>
                                                    </div>
                                                    <div class="transpond_detail">
                                                        <div
                                                            @click="openDownloadAppPop"
                                                            class="transpond_list"
                                                        >
                                                            <p class="plate">
                                                                <span>{{ item.theme_info.title }}</span>
                                                                &nbsp;&nbsp;
                                                                <span
                                                                    class="to_red"
                                                                    v-if="isGoUp(item.theme_info.chg_pct)"
                                                                >+{{twoDecimalPlaces(item.theme_info.chg_pct) }}</span>
                                                                <span
                                                                    class="to_green"
                                                                    v-else
                                                                >{{twoDecimalPlaces(item.theme_info.chg_pct) }}</span>
                                                            </p>
                                                            <div class="plate_info_right">
                                                                <p
                                                                    class="plate_stock_info"
                                                                    v-for="item in item.theme_info.head_stocks.slice(0,2)"
                                                                >
                                                                    <span>{{ item.data.stock_name }}</span>
                                                                    &nbsp;&nbsp;
                                                                    <span
                                                                        :class="isGoUp(item.data.stock_rise) ? 'to_red' : 'to_green'"
                                                                    >{{item.data.stock_rise}}%</span>
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div
                                                            v-if="!item.theme_info.is_follow || item.theme_info.is_follow === 'no'"
                                                            @click="handleClickToAddOptional(item.theme_info.symbol ,'BK', item.theme_info)"
                                                            class="add_optional"
                                                        >加自选</div>
                                                        <div
                                                            v-else
                                                            @click="handleClickToDelOptional(item.theme_info.symbol ,'BK', item.theme_info)"
                                                            class="add_optional del_optional"
                                                        >已添加</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- 分享竞猜 -->
                                        <div
                                            v-if="item.data.o_kind === 'stock_discuss_sh'"
                                            class="transpond_plate_wrap transpond_guess"
                                            @click="hanleClickToPage(`/StockGuess/market/id/${item.data.guess.guess_id}`)"
                                        >
                                            <div class="transpond_plate_content">
                                                <div class="transpond_title">
                                                    <img
                                                        alt
                                                        src="https://cdndev.aigupiao.com/static/pc/img/plate_ico_1.png"
                                                    />
                                                    <div class="plate_img_text">趣味竞猜</div>
                                                </div>
                                                <div class="transpond_detail">
                                                    <div class="guess_list">
                                                        <h5
                                                            class="guess_title"
                                                        >{{item.data.guess.title}}</h5>
                                                        <p
                                                            class="guess_num"
                                                        >参与人数：{{item.data.guess.total_num}}</p>
                                                    </div>
                                                    <div class="guess_btns">
                                                        <div class="guess_btn">查看竞猜</div>
                                                        <div class="guess_btn">跟单</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            class="transpond_plate_wrap"
                                            v-if="msg.forward_info[0].share_kind&&msg.forward_info[0].share_kind === 'stock'"
                                        >
                                            <div class="transpond_plate_content">
                                                <div
                                                    class="transpond_title"
                                                    @click="handleClickToStockPage(msg.forward_info[0].share_msg.stock_code)"
                                                >
                                                    <img
                                                        alt
                                                        src="https://cdndev.aigupiao.com/static/pc/img/plate_ico_1.png"
                                                    />
                                                    <div class="plate_img_text">股票</div>
                                                </div>
                                                <div class="transpond_detail">
                                                    <div
                                                        class="transpond_list"
                                                        @click="handleClickToStockPage(msg.forward_info[0].share_msg.stock_code)"
                                                    >
                                                        <p class="plate">
                                                            <span>{{msg.forward_info[0].share_msg.stock_name}}</span>
                                                            <span
                                                                class="stock-code"
                                                            >{{msg.forward_info[0].share_msg.stock_code}}</span>
                                                        </p>
                                                        <div class="plate_info_right">
                                                            <p
                                                                v-if="msg.forward_info[0].share_msg.stock_market"
                                                                :class="['plate_stock_info', isGoUp( msg.forward_info[0].share_msg.stock_market.chg_pct ) ? 'to_red' : 'to_green']"
                                                            >
                                                                <span>{{msg.forward_info[0].share_msg.stock_market.price}}</span>
                                                                &nbsp;&nbsp;
                                                                <span>{{isGoUp( msg.forward_info[0].share_msg.stock_market.chg_pct ) ? '+' : ''}}{{ msg.forward_info[0].share_msg.stock_market.chg_pct }}%</span>
                                                            </p>
                                                            <p class="plate_stock_info">
                                                                <span>{{msg.forward_info[0].share_msg.comment_num}}</span>
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div
                                                        v-if="!msg.forward_info[0].share_msg.is_follow || msg.forward_info[0].share_msg.is_follow === 'no'"
                                                        @click="handleClickToAddOptional(msg.forward_info[0].share_msg.stock_code, 'SH', msg.forward_info[0].share_msg)"
                                                        class="add_optional"
                                                    >加自选</div>
                                                    <div
                                                        v-else
                                                        @click="handleClickToDelOptional(msg.forward_info[0].share_msg.stock_code, 'SH', msg.forward_info[0].share_msg)"
                                                        class="add_optional del_optional"
                                                    >已添加</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 仅粉丝可见+不可见 -->
                <div v-if="is_fans_show_ok === false"  @click="handleClickToLiveDetail">
                    <div class="live_content">
                        <div class="live_content_fans_noshow">
                            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                                <circle cx="10.2792" cy="5.81181" r="4.48838" stroke="#EC596C" stroke-width="1.1"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M15.9967 20C15.9967 20 11.9829 17.4829 11.7657 15.5251C11.5486 13.5674 12.7869 12.6553 13.8812 12.6553C14.9755 12.6553 15.9967 13.4155 15.9967 13.4155C15.9967 13.4155 17.1063 12.6553 18.2107 12.6553C19.3152 12.6553 20.3106 13.9898 20.1399 15.5251C19.9692 17.0604 15.9967 20 15.9967 20Z" fill="#EC596C" fill-opacity="0.35" stroke="#EC596C" stroke-width="1.1"/>
                                <path d="M10.2797 10.3C10.2797 10.3 2.67936 9.94479 2.3093 18.3255C2.3093 18.5357 2.44403 18.6332 2.50526 18.7232C2.69335 18.9996 3.45701 19.1062 3.45701 19.1062H10.2797" stroke="#EC596C" stroke-width="1.1" stroke-linecap="round"/>
                            </svg>
                            此内容仅粉丝可见，关注作者后即可查看
                        </div>
                        
                    </div>
                </div>
            </div>
            <!-- 是否是高手专栏 -->
            <div v-if="msg.kind === 'charge'">
                <div class="special_column" @click="handleClickToLiveDetail(msg.id)">
                    <h4 class="special_column_title">{{msg.title}}</h4>
                    <p class="special_column_content" v-html="msg.brief || msg.content "></p>
                </div>
                <div v-if="msg.image_thumb && msg.image_thumb.length > 0 ">
                    <image-viewpoint :msg="msg"></image-viewpoint>
                </div>
            </div>
            <div v-if="msg.kind === 'user_msg' && msg.content_type !== '0' ">
                <div class="special_column" @click="handleClickToLiveDetail(msg.id)">
                    <h4 class="special_column_title">{{msg.title}}</h4>
                    <p class="special_column_content" v-html="msg.content"></p>
                </div>
                <div v-if="msg.image_thumb && msg.image_thumb.length > 0 ">
                    <image-viewpoint :msg="msg"></image-viewpoint>
                </div>
            </div>
        </div>
        <div class="live_footer">
            <div class="footer_top_border">
                <div class="give_like">
                    <span class="ub align-items justify-content" @click="handleClickToLike">
                        <img
                            v-if="isOccurLike"
                            :src="require('@/assets/images/icon-good-red@2x.png')"
                            alt
                        />
                        <img
                            v-if="!isOccurLike"
                            :src="require('@/assets/images/icon-good-gray@2x.png')"
                            alt
                        />
                        <span
                            :class="['support_num', isOccurLike ? 'to_red' : '']"
                        >{{msg.support_num}}</span>
                    </span>
                </div>
                <div class="give_comment">
                    <span class="ub align-items justify-content" @click="$downapppop.open('分享')">
                        <img class="give_img" src="https://cdncos.aigupiao.com/assets/wap/img/give_share@2x.png" > 
                            <span>分享</span>
                    </span>
                </div>
                <div class="give_comment" @click="handleClickToComment">
                    <span class="ub align-items justify-content">
                        <img
                            v-if="+msg.comment_num > 0"
                            :src="require('@/assets/images/icon-comment_red@3x.png')"
                            alt
                        />
                        <img
                            v-if="+msg.comment_num <= 0"
                            :src="require('@/assets/images/icon-comment@2x.png')"
                            alt
                        />
                        <span :class="+msg.comment_num > 0 ?'to_red': ''">{{msg.comment_num}}</span>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import imageViewpoint from "./imageViewpoint";
import AudioMsgWrap from "../AudioMsgWrap/AudioMsgWrap";
import HomePageApi from "@/api/homePage/";
import PublicApi from "@/api/publicApi/";
export default {
    name: "UserLiveListPub",
    data() {
        return {
            isOccurLike: false,
            randomStr: Math.random().toString(36).slice(-4),
            dataView: [
                "robot",
                "ad",
                "qa",
                "mix",
                "k_line_training_camp",
                "guess",
                "comment"
            ],
            user_id: parseInt(this.$route.params.id),
            img_height:40,
            imgwidth:0,
        };
    },
    props: {
        live: Object,
        msg: Object,
    },
    computed: {
        hasGetInfo() {
            return this.$store.state.user.hasGetInfo;
        },
        is_fans_show_ok(){
            //用于设置了 仅粉丝可见
            if(this.msg.is_fans_show == 1){
                if(this.$store.state.user.is_follow == 'yes'){
                    //可见状态
                    return true;
                }
                else{
                    //不可见状态
                    return false;
                }
            }
            return 0;
        }
    },
    components: {
        imageViewpoint,
        AudioMsgWrap,
    },
    created() {
        console.log(this.$store.state.user.is_follow,'is_follow')
        this.getimage();
    },
    methods: {
        handleClickToLike() {
            //点赞功能
            let { id, kind, support_num } = this.msg;
            // const getLoginData = this.props.loginStore.loginData || {};
            // if (!getLoginData.token) {``
            // this.props.history.push('/default/login');
            // todo login
            // return null;
            // }
            if (!this.isOccurLike) {
                this.isOccurLike = true;
                this.msg.support_num = parseInt(support_num) + 1;
                let type = "live_msg";
                this.addPraise(id, type);
            }
        },
        addPraise(id, type) {
            PublicApi.addPraise(id, type);
        },
        // 资讯跳转详情
        handleClickNewsDetail(id) {
            let uri =
                location.origin === "http://192.168.31.170:8080"
                    ? "https://mobilebeta.aigupiao.com"
                    : "";
            // this.props.history.push(`/importNewsDetail/${id}#comment`)
            // window.location.href = `https://mobile.aigupiao.com/express/detail/id/${ id }/jump_type/2.html`//跳转老项目
            window.location.href = `${uri}/express/detail/id/${id}`; //跳转老项目
        },
        handleClickToTranspondLiveDetail(kind, id) {
            // let {id} = this.props.msg;
            // this.props.history.push({pathname:`/liveDetail/${id}`});
            if (kind === "user_msg") {
                // window.location.href = `https://mobiledev.aigupiao.com/lives/usermsg/id/${ id }/jump_type/1.html`
                window.location.href = `/lives/usermsg/id/${id}/jump_type/1.html`;
                //如果是老师的动态跳转到老师动态详情
            } else {
                // window.location.href = `https://mobiledev.aigupiao.com/lives/detail/id/${ id }/jump_type/1.html`
                window.location.href = `/lives/detail/id/${id}/jump_type/1.html`;
            }
        },
        //点击文章跳转直播详情页面
        handleClickToLiveDetail(id, kind = "user_msg") {
            //仅粉丝可见
            if(this.is_fans_show_ok === false){
                this.$downapppop.open('查看');
                return false;
            }
            // let {id} = this.props.msg;
            // this.props.history.push({pathname:`/liveDetail/${id}`});
            if (kind === "user_msg") {
                // window.location.href = `https://mobiledev.aigupiao.com/lives/usermsg/id/${ id }/jump_type/1.html`
                window.location.href = `/lives/usermsg/id/${id}/jump_type/1.html`;
                //如果是老师的动态跳转到老师动态详情
            } else {
                // window.location.href = `https://mobiledev.aigupiao.com/lives/detail/id/${ id }/jump_type/1.html`
                window.location.href = `/lives/detail/id/${id}/jump_type/1.html`;
            }
        },
        //点击评论跳转至直播详情页
        handleClickToComment() {
            //仅粉丝可见
            if(this.is_fans_show_ok === false){
                this.$downapppop.open('查看');
                return false;
            }
            
            let { id, kind } = this.msg;
            if (kind === "user_msg") {
                // window.location.href = `https://mobiledev.aigupiao.com/lives/usermsg/id/${ id }/jump_type/2.html`
                window.location.href = `/lives/usermsg/id/${id}/jump_type/2.html`;

                //如果是老师的动态跳转到老师
            } else {
                // window.location.href = `https://mobiledev.aigupiao.com/lives/detail/id/${ id }/jump_type/2.html`
                window.location.href = `/lives/detail/id/${id}/jump_type/2.html`;
            }
        },
        //点击文章跳转直播详情页面
        handleClickToStockGuess(id, kind) {
            if (kind === "user_msg") {
                // window.location.href = `https://mobiledev.aigupiao.com/lives/usermsg/id/${ id }/jump_type/1.html`
                window.location.href = `/lives/usermsg/id/${id}/jump_type/1.html`;
                //如果是老师的动态跳转到老师动态详情
            } else {
                // window.location.href = `https://mobiledev.aigupiao.com/lives/detail/id/${ id }/jump_type/1.html`
                window.location.href = `/lives/detail/id/${id}/jump_type/1.html`;
            }
        },
        handleClickToDetail(kind, id) {
            //如果已经在个人主页则不再做跳转
            if (this.user_id === parseInt(id)) {
                return null;
            }
            //如果是用户发的动态，则跳到用户的个人主页
            if (kind === "user_msg") {
                // this.props.history.push({pathname:`/default/userProfiles/${id}`,state:{type:'user'}})
                // window.location.href = `https://mobiledev.aigupiao.com/ucenter/user_home/m_u_id/${ id }.html`
                window.location.href = `/ucenter/user_home/m_u_id/${id}.html`;

                //如果是老师的动态跳转到老师的个人主页
            } else {
                // this.props.history.push({pathname:`/default/userProfiles/${id}`,state:{type:'teacher'}})
                // window.location.href = `https://mobiledev.aigupiao.com/lives/center/id/${ id }.html`
                window.location.href = `/lives/center/id/${id}.html`;
            }
        },
        //点击股票区域
        handleClickToStockPage(code) {
            // let urlPath = `https://mobile.aigupiao.com/StockPage/stock/code/${ code }.html`
            let urlPath = `/StockPage/stock/code/${code}.html`;
            window.location.href = urlPath;
        },
        openDownloadAppPop() {
            this.$downapppop.open();
        },
        async handleClickToAddOptional(stock_code, type, data) {
            if (!this.hasGetInfo) {
                this.$confirm({
                    title: "您还没有登录，是否登陆？",
                    yesBtnText: "确定",
                })
                    .then(() => {
                        window.location.href =
                            "/login/index/rd/" + new Date() * 1 + ".html";
                    })
                    .catch(() => {});
            } else {
                let addStockStatus = await HomePageApi.addStock(
                    stock_code,
                    type
                );
                if (addStockStatus.status === "success") {
                    this.$set(data, "is_follow", "yes");
                }
            }
        },
        //点击已加入
        handleClickToDelOptional(stock_code, type, data) {
            if (!this.hasGetInfo) {
                this.$confirm({
                    title: "您还没有登录，是否登陆？",
                    yesBtnText: "确定",
                })
                    .then(() => {
                        window.location.href =
                            "/login/index/rd/" + new Date() * 1 + ".html";
                    })
                    .catch(() => {});
            } else {
                this.$confirm({
                    title: "确定从自选股中移出？",
                    yesBtnText: "确定",
                })
                    .then(() => {
                        HomePageApi.delStock(stock_code, type).then((res) => {
                            if (res.status === "success") {
                                this.$set(data, "is_follow", "no");
                            }
                        });
                    })
                    .catch(() => {
                        // console.log('cancel')
                    });
            }
        },
        getimage(){
            let img = new Image();
            img.src = this.live.image;
            var _this = this;
            img.onload = function(){
                _this.imgwidth = parseInt(_this.img_height / parseInt(img.height)  * parseInt(img.width));
                console.log(_this.imgwidth);
            }
        }
    },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.live_item:last-child {
    margin-bottom: 0;
}

.live_item {
    background: #fff;
    margin-bottom: 10px;
    //强制英文长单词换行
    word-break: break-all;
    word-wrap: break-word;

    .is_only_self_show {
        height: 34px;
        background-image: url("../../assets/images/icon_only_self_show@2x.png");
        background-repeat: no-repeat;
        background-size: 12px 14px;
        background-position: 12px 10px;
        text-indent: 30px;
        color: #919191;
        line-height: 34px;
        font-size: 14px;
        width: 100%;
        position: relative;
        &::after {
            content: " ";
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            height: 1px;
            border-bottom: .5px solid #c7c7c7;
        }

        &.is_fans_show{
            background: none;
            display: flex;
            align-items: center;
            text-indent: 0;
            svg{
                width: 14px;
                height: 14px;
                flex-shrink: 0;
                margin-left: 12px;
                margin-right: 4px;
            }

        }
    }

    //头部样式
    .live_header {
        padding: 14px 14px;
        display: flex;
        justify-content: space-between;

        .user_detail {
            display: flex;

            dt {
                width: 40px;
                height: 40px;
                border: 1px solid #e6e6e6;
                border-radius: 50%;
                margin-right: 10px;
                overflow: hidden;

                > img {
                    width: 100%;
                    height: 100%;
                    display: block;
                    object-fit: cover;
                }
            }

            dd {
                flex: 1;

                h4 {
                    display: flex;
                    align-items: center;
                    margin-bottom: 6px;

                    .user_name {
                        font-size: 15px;
                        color: #222222;
                        font-weight: 500;
                        height: 18px;
                        line-height: 18px;
                    }

                    .user_symbol {
                        width: 14px;
                        height: 14px;
                        margin-left: 6px;
                        line-height: 0;

                        > img {
                            width: 100%;
                            height: 100%;
                        }
                    }
                }

                p {
                    font-size: 13px;
                    line-height: 18px;
                    color: #636363;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }
            }
        }

        .user_operation {
            width: 14px;
            height: 2px;
            margin-right: 3px;

            img {
                width: 100%;
                height: 100%;
            }
        }
    }

    //纯文字样子
    .live_content {
        color: #222222;
        font-size: 16px;
        line-height: 24px;
        padding: 0px 14px 5px;

        .live_content_fans_noshow{
            display: flex;
            align-items: center;
            height: 42px;
            color: #636363;
            border-top: .5px solid #ebebeb;
            border-bottom: .5px solid #ebebeb;
            svg{
                margin-left: 6px;
                margin-right: 12px;
                width: 22px;
                height: 22px;
                flex-shrink: 0;
            }
        }

        > div {
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 4;
            overflow: hidden;
        }

    }

    //图片样式
    .thumbnail {
        display: flex;
        padding: 0 6px 14px;

        .img-item {
            width: 33.33%;
        }

        > div {
            height: 111px;
            width: 111px;
            margin: 3px;

            > img {
                width: 100%;
                height: 100%;
            }
        }
    }

    .transmit_image {
        padding: 6px 6px 0;
        // height: 136px;
    }

    //视频专辑样式
    .video_special {
        padding: 6px 14px 0;

        .video_cover {
            height: 198px;
            position: relative;

            > img {
                width: 100%;
                height: 100%;
            }

            .play_btn {
                position: absolute;
                top: 50%;
                left: 50%;
                margin-top: -23px;
                margin-left: -23px;
                width: 47px;
                height: 47px;

                > img {
                    width: 100%;
                    height: 100%;
                }
            }
        }

        .video_special_detail {
            display: flex;
            box-sizing: content-box;
            height: 64px;
            justify-content: space-between;
            padding-bottom: 14px;

            > div {
                height: 100%;
                display: flex;
                flex: 1;
                flex-direction: column;
                // justify-content: space-around;
                padding-right: 25px;

                > h4 {
                    width: 275px;
                    height: 17px;
                    font-size: 16px;
                    // color:@color-gray-high;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    font-weight: 400;
                    margin: 10px 0 6px 0;
                    line-height: 17px;
                }

                > p {
                    font-size: 14px;
                    // color:@color-gray-middle;
                    width: 275px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
            }

            > dl {
                flex-shrink: 0;
                height: 100%;
                display: flex;
                flex-direction: column;
                // justify-content: space-around;
                align-items: center;

                > dt {
                    width: 27px;
                    height: 22px;
                    margin: 9px 0 6px 0;

                    > img {
                        width: 100%;
                        height: 100%;
                    }
                }

                > dd {
                    font-size: 14px;
                    color: #fe696b;
                }
            }
        }
    }

    //会员消息不能看全部的样式
    .members_only {
        .members_only_free {
            padding: 6px 14px 0;
            color: #222222;
            font-size: 16px;
            line-height: 24px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 4;
            overflow: hidden;

            .user_name {
                color: #507daf;
                margin-right: 5px;
            }
        }

        .transpond {
            background: #f7f7f7;
        }

        .members_only_box {
            // margin: 10px 12px 0;
            // padding-left: 0 18px;
            padding: 12px 18px 0;

            &.zf {
                background: #f7f7f7;
            }

            .vip_nosee_company {
                height: 56px;
                display: flex;
                align-items: center;
                border-top: 1px solid #ebebeb;

                span {
                    width: 27px;
                    height: 28px;
                    background: url(https://cdn.aigupiao.com/static/wap/img/Popularize/vip-lock.png);
                    margin-right: 15px;
                    background-size: 99% 99%;
                    background-repeat: no-repeat;
                }

                .vip_company_info {
                    b {
                        font: 16px/21px "微软雅黑";
                        color: #939393;
                        display: block;
                        font-weight: 500;
                    }
                }
            }
        }
    }

    //会员消息可看全部的样式
    .member_brief {
        font-size: 16px;
        line-height: 22px;
        padding: 6px 12px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 4;
        overflow: hidden;

        .user_name {
            color: #507daf;
            margin-right: 5px;
        }
    }

    .transpond {
        background: #f7f7f7;
    }

    .member_news {
        background: #fffbf0;

        .member_news_header {
            height: 54px;
            box-sizing: border-box;
            padding: 8px 0 7px 12px;
            border-top: 1px solid #ffe4cf;
            border-bottom: 1px solid #ffe4cf;

            > dl {
                height: 100%;
                display: flex;
                align-items: center;

                > dt {
                    width: 21px;
                    height: 21px;
                    flex-shrink: 0;

                    > img {
                        width: 100%;
                        height: 100%;
                    }
                }

                > dd {
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    margin-left: 9px;

                    > h4 {
                        color: #ff8f17;
                        font-size: 16px;
                        line-height: 22px;
                    }

                    > p {
                        color: #ff8f17;
                        font-size: 12px;
                        line-height: 17px;

                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 4;
                        overflow: hidden;
                    }
                }
            }
        }

        .member_news_content {
            color: #333333;
            font-size: 16px;
            line-height: 22px;
            padding: 12px;
        }
    }

    //尾部评论点赞样式
    .live_footer {
        width: 100%;
        height: 44px;
        box-sizing: border-box;

        .footer_top_border {
            //border-top: 1px solid #e6e6e6;
            display: flex;
            width: 100%;
            height: 44px;
            align-items: center;
            color: #636363;

            .give_like {
                margin: 9px 0;
                flex: 1;
                text-align: center;
                font-size: 14px;
                line-height: 17px;

                .support_num {
                    padding-top: 3px;
                }

                span img {
                    width: 17px;
                    height: 17px;
                    margin-right: 6px;
                }

                .to_red {
                    // color:@color-red;
                }
            }

            .give_comment {
                margin: 9px 0;
                flex: 1;
                text-align: center;
                font-size: 14px;
                line-height: 17px;

                .give_img{
                    width:16.33px;
                    height:14px;
                }

                span img {
                    width: 17px;
                    height: 17px;
                    margin-right: 6px;
                }
            }
        }
    }

    //专栏样式
    .special_column {
        padding: 0 14px 14px;

        .special_column_title {
            font-size: 16px;
            font-weight: bold;
            color: #222222;
            font-family: PingFangSC-Medium;
            line-height: 24px;
            margin-bottom: 6px;
            //最多两行显示
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
        }

        .special_column_content {
            color: #636363;
            font-size: 16px;
            line-height: 22px;
            //专栏最多3行显示
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            overflow: hidden;
        }
    }

    //转发板块 和转发股票
    .transpond_plate_wrap {
        padding: 0 14px 14px 14px;

        .transpond_plate_content {
            height: 82px;
            display: flex;

            .transpond_title {
                width: 82px;
                height: 82px;
                overflow: hidden;
                position: relative;
                flex-shrink: 0;

                > img {
                    width: 100%;
                    height: 100%;
                }

                > div {
                    position: absolute;
                    width: 100%;
                    height: 23px;
                    background: rgba(0, 0, 0, 0.4);
                    left: 0;
                    bottom: 0;
                    text-align: center;
                    line-height: 23px;
                    color: #fff;
                    font-size: 12px;
                    font-weight: 400;
                }
            }

            .transpond_detail {
                flex: 1;
                display: flex;
                padding: 0 14px;
                justify-content: space-between;
                align-items: center;
                background: #f9f9f9;

                .transpond_list {
                    .plate {
                        color: #222222;
                        font-size: 16px;
                        line-height: 18px;
                        margin: 12px 0 8px 0;

                        .stock-code {
                            color: #636363;
                            margin-left: 6px;
                        }
                    }

                    .plate_info_right {
                        > p {
                            color: #636363;
                            font-size: 12px;
                            font-weight: 400;
                            line-height: 16px;
                            margin-bottom: 4px;
                        }

                        .to_green {
                            color: #0ac890;
                        }

                        .to_red {
                            color: #fe484a;
                        }
                    }
                }

                .add_optional {
                    width: 64px;
                    height: 32px;
                    background: #fe484a;
                    border-radius: 4px;
                    font-size: 13px;
                    line-height: 32px;
                    text-align: center;
                    color: #fff;
                }

                .del_optional {
                    background: #cbcbcb;
                }
            }
        }
    }

    .to_green {
        color: #0ac890;
    }

    .to_red {
        color: #fe484a;
    }

    .AGP_face {
        width: 18px;
        height: 18px;
        vertical-align: sub;
    }
}

//转发竞猜
.transpond_guess {
    .guess_list {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .guess_title {
            color: #222222;
            font-size: 15px;
            line-height: 18px;
            margin-top: 12px;
        }

        .guess_num {
            font-size: 12px;
            line-height: 16px;
            color: #636363;
            margin-bottom: 7px;
        }
    }

    .guess_btns {
        display: flex;
        flex-direction: column;
        height: 100%;
        justify-content: space-around;

        > div.guess_btn {
            width: 64px;
            height: 28px;
            background: rgba(254, 72, 74, 1);
            border-radius: 4px;
            color: #ffffff;
            text-align: center;
            font-size: 13px;
            line-height: 28px;
        }
    }
}

.vedio_img {
    // width: 100px !important;
    background-color: red;
    height: 100%;

    .vedio_image {
        display: block;
        height: 100%;
        position: relative;

        > img {
            height: 100%;
            width: 100%;
        }

        p {
            position: absolute;
            width: 100%;
            height: 100%;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            margin: auto;

            .vedio_time {
                position: absolute;
                bottom: 0;
                right: 0;
                width: 70px !important;
                height: 23px !important;
                background: rgba(0, 0, 0, 0.5);

                .vedio_time_icon {
                    line-height: 23px;
                    width: 17px !important;
                    height: 17px !important;
                    margin-left: 7px;
                }

                > i {
                    color: #fff;
                    font-size: 14px !important;
                    line-height: 23px !important;
                    padding-left: 10px;
                }
            }
        }
    }
}

.vedio_play {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 46px !important;
    height: 46px !important;
}

//转发资讯样式
.transpond_important_news {
    background: #f7f7f7;
    padding: 12px;

    > p {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 5;
        overflow: hidden;
        font-size: 15px;
        line-height: 20px;
        color: #5b5b5b;
    }

    .important_news_mark {
        color: #feb80d;
    }
}

//转发专栏样式
.transpond_special_column {
    padding: 0px 14px 12px 12px;
    background: #f7f7f7;

    .user_msg {
        display: flex;
        height: 39px;
        align-items: center;

        .user_name {
            font-size: 15px;
            color: #507daf;
            line-height: 21px;
        }

        .content_type {
            width: 48px;
            height: 15px;
            margin-left: 9px;

            > img {
                width: 100%;
                height: 100%;
            }
        }
    }

    .transpond_box {
        // width: 100%;
        display: flex;
        padding: 11px;
        background: #fff;

        .user_img {
            width: 60px;
            height: 60px;
            flex-shrink: 0;

            > img {
                width: 100%;
                height: 100%;
            }
        }

        .transpond_content {
            display: flex;
            flex-direction: column;
            padding: 0 15px 0 11px;
            justify-content: space-between;

            .transpond_title {
                font-size: 14px;
                line-height: 19px;
                color: #636363;
                display: -webkit-box;
                display: -moz-box;

                -webkit-box-orient: vertical;
                -moz-box-orient: vertical;

                -webkit-line-clamp: 1;
                -moz-line-clamp: 1;

                overflow: hidden;
            }

            .transpond_brief {
                font-size: 12px;
                color: #636363;
                line-height: 18px;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                overflow: hidden;
            }
        }
    }
}

//转发普通消息
.transpond_ordinary {
    .forward-main {
        .transpond_plate_wrap {
            padding: 12px 14px 0 14px;
        }

        .transpond_detail {
            background: #fff !important;
        }
    }

    background: #f7f7f7;
    padding-bottom: 12px;

    .transpond_ordinary_content {
        padding: 12px 12px 0;
        font-size: 15px;
        line-height: 21px;
        color: #636363;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 4;
        overflow: hidden;

        .user_name {
            color: #507daf;
            margin-right: 5px;
        }
    }

    .audio_msg_box {
        padding: 12px 12px 0;

        .audio_msg_content {
            background-color: #fff;
        }
    }
}

//转发和分享不支持内容
.nonsupport_box {
    // font-size: 12px;
    // padding-right:25px;
    padding: 12px 0;
    text-align: center;
    line-height: 22px;
    background: #eee;

    > a {
        color: #4e7aa2;
    }
}

.dl_check_box {
    padding-left: 12px;
}
</style>